import { useApiQuery } from 'api';
import CachedApi from 'cache/CachedApi';
import ClassIndicator from 'components/ClassIndicator';
import { Badge, Page, SubNav, Main, Button } from 'components/common';
import Header from 'components/page/Header';
import LoadingPage from 'layouts/LoadingPage';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import styled from 'styled-components';

const Results = () => {
  const modal = useSelector(s => s.ui.modal);
  const schoolId = useSelector(s => s.school.schoolId);
  const teacherId = useSelector(
    store => store.school?.currentSchool?.teacher?.teacherId
  );
  const { groupId, studentCount } = useSelector(({ group }) => group);

  const { loading, data, reload } = useApiQuery(async () => {
    if (!groupId) {
      return null;
    }

    const assignments = await CachedApi.getTeacherAssignmentInsights(
      teacherId,
      'All',
      groupId,
      1,
      3,
      ['all']
      //sort
    );

    const retrievalPracticeAssignment =
      await CachedApi.getGroupRetrievalPractice(groupId);

    return {
      assignments,
      retrievalPracticeAssignment
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, teacherId, modal]); // [modal] dependency is required for this to be reloaded upon closing on setwork modal

  if (loading) return <LoadingPage />;

  return (
    <Page title="Results">
      {groupId && !studentCount ? (
        <Banner>
          <h2>Now let's set up your students</h2>
          <p>Now you need to get students to log in and answer the questions</p>
          <Button color="primary" to={`/${schoolId}/settings/students`}>
            Add students
          </Button>
        </Banner>
      ) : (
        <></>
      )}

      <Header showNotifications={true}>
        <Header.Title>
          <h1>
            Results <ClassIndicator />
          </h1>
        </Header.Title>
        <SubNav
          tabs={[
            { label: 'Assignments', to: `/${schoolId}/assignments` },
            {
              label: (
                <>
                  Retrieval Practice
                  <Badge color="green" textcolor="white" className="ml-2">
                    New
                  </Badge>
                </>
              ),
              to: `/${schoolId}/retrieval-practice`
            },
            {
              label: 'Independent Study',
              to: `/${schoolId}/independent-study`
            }
          ]}
        />
      </Header>
      <Main>
        <Outlet
          context={{
            reload,
            assignments: data?.assignments,
            retrievalPracticeAssignment: data?.retrievalPracticeAssignment
          }}
        />
      </Main>
    </Page>
  );
};

const Banner = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  background-color: var(--green-lighter);
  align-items: center;
  margin-top: 2rem;
  padding: 2rem;
`;

export default Results;
